import { useState } from 'react'

import { Box, Card, Grid } from '@factorialco/deprecated-design-system'
import { MyCardFragment } from 'generated/resources/graphql'

import useSearchParams from 'modules/core/hooks/useSearchParams'

import { CardSidepanel } from 'modules/banking/components/CardSidepanel'

import CardBox from './CardBox'

interface CardRowProps {
  cards: MyCardFragment[]
}

interface CardCardProps {
  card: MyCardFragment
}

const CardCard = ({ card }: CardCardProps) => {
  const [showCardSidePanel, setShowCardsSidePanel] = useState(false)

  return (
    <>
      <Card onClick={() => setShowCardsSidePanel(true)}>
        <Card.Content>
          <CardBox card={card} />
        </Card.Content>
      </Card>
      {showCardSidePanel && (
        <CardSidepanel cardId={card.id} onClose={() => setShowCardsSidePanel(false)} />
      )}
    </>
  )
}

const CardsGrid = ({ cards }: CardRowProps) => {
  const { showCard: showCardValue } = useSearchParams<{
    showCard?: string
  }>()
  const [sidepanelCardId, setSidepanelCardId] = useState<string | null>(
    showCardValue ? String(showCardValue) : null
  )

  return (
    <Grid variant="fixed">
      {cards.map((card) => (
        <Box gridColSpan={{ xxs: 12, s: 6, m: 4 }} key={card.id}>
          <CardCard card={card} />
        </Box>
      ))}

      {sidepanelCardId && (
        <CardSidepanel cardId={sidepanelCardId} onClose={() => setSidepanelCardId(null)} />
      )}
    </Grid>
  )
}

export default CardsGrid
